var render = function render(){var _vm=this,_c=_vm._self._c;return _c('remote-js',{attrs:{"src":this.jsUrl},on:{"load-js-finish":this.jsLoadCallBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }